/* Tinsel Trove — global.js
   Cart drawer, AJAX add to cart, variant picker, gallery, sticky ATC */
(function () {
  'use strict';

  /* ---------- money formatting ---------- */
  function formatMoney(cents) {
    var format = window.themeMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* ---------- mobile nav drawer ---------- */
  var mobileNav = document.getElementById('MobileNav');
  var burger = document.querySelector('[data-mobile-nav-open]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-nav-open]')) openMobileNav();
    if (e.target.closest('[data-mobile-nav-close]')) closeMobileNav();
    if (mobileNav && e.target.closest('.mobile-nav__links a')) closeMobileNav();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMobileNav();
  });

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeDrawer();
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      refreshCart().then(openDrawer);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function renderCart(cart) {
    if (!drawer) return;
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var countEls = document.querySelectorAll('[data-cart-count]');

    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (itemsEl) {
      if (cart.items.length === 0) {
        itemsEl.innerHTML =
          '<div class="cart-drawer__empty"><p>Your sleigh is empty — let\'s fix that.</p>' +
          '<a class="button button--berry" href="/">Keep browsing</a></div>';
      } else {
        itemsEl.innerHTML = cart.items
          .map(function (item, i) {
            var variantTitle =
              item.variant_title && item.variant_title !== 'Default Title'
                ? '<p class="cart-line__variant">' + item.variant_title + '</p>'
                : '';
            var img = item.image
              ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x160$1$2') + '" alt="">'
              : '';
            return (
              '<div class="cart-line" data-line="' + (i + 1) + '">' +
              img +
              '<div class="cart-line__info">' +
              '<p class="cart-line__title">' + item.product_title + '</p>' +
              variantTitle +
              '<div class="cart-line__row">' +
              '<span class="cart-line__qty">' +
              '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
              '</span>' +
              '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
              '<button type="button" class="cart-line__remove" data-remove>Remove</button>' +
              '</div></div>'
            );
          })
          .join('');
      }
    }

    /* free-shipping progress bar */
    var shipbar = drawer.querySelector('[data-ship-threshold]');
    if (shipbar) {
      var threshold = parseInt(shipbar.getAttribute('data-ship-threshold'), 10);
      var textEl = shipbar.querySelector('[data-ship-text]');
      var fillEl = shipbar.querySelector('[data-ship-fill]');
      if (threshold > 0) {
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        if (fillEl) fillEl.style.width = pct + '%';
        if (textEl) {
          textEl.textContent =
            cart.total_price >= threshold
              ? '🎉 You unlocked FREE shipping!'
              : 'Add ' + formatMoney(threshold - cart.total_price) + ' more for FREE shipping';
        }
      } else {
        shipbar.style.display = 'none';
      }
    }
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  drawer && drawer.addEventListener('click', function (e) {
    var line = e.target.closest('.cart-line');
    if (!line) return;
    var lineNum = line.getAttribute('data-line');

    if (e.target.closest('[data-remove]')) {
      changeLine(lineNum, 0);
    }
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var current = parseInt(line.querySelector('.cart-line__qty span').textContent, 10);
      changeLine(lineNum, Math.max(0, current + parseInt(qtyBtn.getAttribute('data-qty-change'), 10)));
    }
  });

  function changeLine(line, quantity) {
    fetch(window.themeRoutes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var originalText = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = 'Adding…'; }

    fetch(window.themeRoutes.cartAdd + '.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () {
        openDrawer();
        if (button) { button.disabled = false; button.innerHTML = originalText; }
      })
      .catch(function (err) {
        if (button) { button.disabled = false; button.innerHTML = originalText; }
        alert(err.message);
      });
  });

  /* ---------- product page ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var variants = JSON.parse(root.querySelector('[data-variants-json]').textContent);
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var saveEl = root.querySelector('[data-save-badge]');
    var idInput = root.querySelector('[data-variant-id]');
    var atcBtn = root.querySelector('[data-atc-button]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function currentSelection() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function matchVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      });
    }

    function updateUI() {
      var v = matchVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.style.display = '';
          if (saveEl) {
            var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
            saveEl.textContent = 'SAVE ' + pct + '%';
            saveEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
      if (atcBtn) {
        if (v.available) {
          atcBtn.disabled = false;
          atcBtn.innerHTML = atcBtn.getAttribute('data-label-add');
        } else {
          atcBtn.disabled = true;
          atcBtn.innerHTML = 'Sold out';
        }
      }
      /* update media if variant has a featured image */
      if (v.featured_image && v.featured_image.src) {
        var mainImg = root.querySelector('[data-main-image]');
        if (mainImg) mainImg.src = v.featured_image.src;
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) updateUI();
    });
    updateUI();

    /* gallery thumbs */
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mainImg = root.querySelector('[data-main-image]');
        if (mainImg) mainImg.src = thumb.getAttribute('data-full');
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* quantity stepper */
    root.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = root.querySelector('[data-qty-input]');
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val + parseInt(btn.getAttribute('data-qty-btn'), 10));
      });
    });
  });

    /* ---------- sticky ATC visibility ---------- */
  var sticky = document.querySelector('.sticky-atc');
  var buyBox = document.querySelector('[data-buy-box]');
  if (sticky && buyBox) {
    var stickyTicking = false;
    function updateStickyAtc() {
      var rect = buyBox.getBoundingClientRect();
      /* Only show once the buy box has been scrolled fully above the header —
         never while it's still below the fold (e.g. behind a tall product image
         on first load), which is what caused it to cover the title/price. */
      var scrolledPast = rect.bottom < 80;
      sticky.classList.toggle('is-visible', scrolledPast);
      stickyTicking = false;
    }
    function onStickyScroll() {
      if (!stickyTicking) {
        window.requestAnimationFrame(updateStickyAtc);
        stickyTicking = true;
      }
    }
    window.addEventListener('scroll', onStickyScroll, { passive: true });
    window.addEventListener('resize', onStickyScroll);
    window.addEventListener('load', updateStickyAtc);
    updateStickyAtc();

    sticky.querySelector('[data-sticky-atc]') &&
      sticky.querySelector('[data-sticky-atc]').addEventListener('click', function () {
        var form = document.querySelector('form[data-ajax-cart]');
        if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
  }

  /* initialize cart count on load */
  refreshCart();
})();
